import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Header from "../Components/Header";

const ErrorPage=()=>{
    useEffect(() => {
                    document.title =
                      "Page Not Found | LDL Settlement Services";
                
                    const metaDesc = document.querySelector("meta[name='description']");
                    if (metaDesc) {
                      metaDesc.setAttribute(
                        "content",
                        "The page you are looking for could not be found. Return to LDL Settlement Services homepage for property settlement assistance."
                      );
                    }
                
                    const canonical = document.querySelector("link[rel='canonical']");
                  if (canonical) {
                    canonical.setAttribute("href", "https://ldlsettlementservices.com.au/404");
                  }
                
                  const ogTitle = document.querySelector("meta[property='og:title']");
                  if (ogTitle) {
                    ogTitle.setAttribute(
                      "content",
                      "Page Not Found | LDL Settlement Services"
                    );
                  }
                
                    const ogDesc = document.querySelector("meta[property='og:description']");
                  if (ogDesc) {
                    ogDesc.setAttribute(
                      "content",
                      "The page you are looking for could not be found. Return to LDL Settlement Services homepage for property settlement assistance."
                    );
                  }
                
                  const ogUrl = document.querySelector("meta[property='og:url']");
                  if (ogUrl) {
                    ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/404");
                  }
                
                    const ogImage = document.querySelector("meta[property='og:image']");
                  if (ogImage) {
                    ogImage.setAttribute(
                      "content",
                      "https://ldlsettlementservices.com.au/Images/home-img.webp"
                    );
                  }
                
                    const twitterTitle = document.querySelector("meta[name='twitter:title']");
                  if (twitterTitle) {
                    twitterTitle.setAttribute(
                      "content",
                      "Page Not Found | LDL Settlement Services"
                    );
                  }
                
                    const twitterDesc = document.querySelector(
                    "meta[name='twitter:description']"
                  );
                  if (twitterDesc) {
                    twitterDesc.setAttribute(
                      "content",
                      "The page you are looking for could not be found. Return to LDL Settlement Services homepage for property settlement assistance."
                    );
                  }
                
                    const twitterImage = document.querySelector("meta[name='twitter:image']");
                  if (twitterImage) {
                    twitterImage.setAttribute(
                      "content",
                      "https://ldlsettlementservices.com.au/Images/home-img.webp"
                    );
                  }
                  }, []);
    return(
        <>
        {/**HEADER */}
        <Header />

      <section className="error-page container">

  <h1 className="hero-title">
    404 <br />
    Page Not Found!
  </h1>

  <p className="section-text">
    The page you are looking for may have been removed,
    renamed, or is temporarily unavailable.
    <br />
    Please return to the homepage or explore another section
    of our website.
  </p>

  <motion.a
    className="primary-btn"
    href="/"
    whileHover={{
      y: -3,
      scale: 1.02,
    }}
    whileTap={{
      scale: 0.97,
    }}
    transition={{
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1],
    }}
  >
    Back to Homepage
  </motion.a>

</section>
        </>
    )
}
export default ErrorPage;